export default __webpack_public_path__ + "static/media/image-four.fc865178.png";